module.exports = __webpack_public_path__ + "img/ch52.184cbe31.png";